import React from 'react';
import {LandingPagePropTypes} from '@ignitesales/neuro-application';
import {GuideNameMessage, LandingPageStartButton, WelcomeMessage, WelcomeTitle} from "../../../../../../../shared/js";

const LandingPage = ({ componentClass }) => {
    return (
        <div className={componentClass}>
            <img src={"/classpath/assets/images/background-curve.png"} alt="background-curve" className={`${componentClass}__background`} />
            <div className="container">
                <div className={`${componentClass}__card`}>
                    <div className="titleSection">
                        <GuideNameMessage tagName="span" />
                    </div>
                    <div className="texturedSection">
                        <WelcomeTitle tagName="h1" />
                    </div>
                    <div className="contentSection">
                        <WelcomeMessage tagName="span" />
                        <LandingPageStartButton />
                    </div>
                </div>
            </div>
        </div>
    );
};

LandingPage.propTypes = LandingPagePropTypes;

export default LandingPage;
